/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Time_Zone_InvalidInputs */

const en_us2_account_time_zone_invalid = /** @type {(inputs: Account_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We do not recognize that time zone.`)
};

const pt_br2_account_time_zone_invalid = /** @type {(inputs: Account_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não reconhecemos esse fuso horário.`)
};

const es_419_account_time_zone_invalid = /** @type {(inputs: Account_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No reconocemos esa zona horaria.`)
};

const pt_pt2_account_time_zone_invalid = /** @type {(inputs: Account_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não reconhecemos esse fuso horário.`)
};

const fr_fr2_account_time_zone_invalid = /** @type {(inputs: Account_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous ne reconnaissons pas ce fuseau horaire.`)
};

const de_de2_account_time_zone_invalid = /** @type {(inputs: Account_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Zeitzone kennen wir nicht.`)
};

const it_it2_account_time_zone_invalid = /** @type {(inputs: Account_Time_Zone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non riconosciamo questo fuso orario.`)
};

/**
* | output |
* | --- |
* | "We do not recognize that time zone." |
*
* @param {Account_Time_Zone_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const account_time_zone_invalid = /** @type {((inputs?: Account_Time_Zone_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Time_Zone_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_account_time_zone_invalid(inputs)
	if (locale === "es-419") return es_419_account_time_zone_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_account_time_zone_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_account_time_zone_invalid(inputs)
	if (locale === "de-DE") return de_de2_account_time_zone_invalid(inputs)
	if (locale === "it-IT") return it_it2_account_time_zone_invalid(inputs)
	return en_us2_account_time_zone_invalid(inputs)
});
export { account_time_zone_invalid as "account.time_zone_invalid" }